import { getStatistics, getStatisticsSubscribers } from '@entities/statistic-info/api'
import { dayjs } from '@shared/lib/dayjs/dayjs'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useState } from 'react'

export const useStatisticsInfo = (channel?: number) => {
    const [dates, setDates] = useState({
        startDate: dayjs().startOf('week').toDate(),
        endDate: dayjs().endOf('week').toDate()
    })

    const queryKey = ['statistics', channel, dates.startDate, dates.endDate]
    const queryKeySub = ['statisticsSub', channel, dates.startDate, dates.endDate]

    const statisticsInfo = useQuery({
        queryKey: queryKey,
        queryFn: () => {
            if (!channel) return
            return getStatistics({ channel, dateStart: dates.startDate, dateEnd: dates.endDate })
        },
        placeholderData: keepPreviousData,
        enabled: !!channel
    })

    const statisticsInfoSubscribers = useQuery({
        queryKey: queryKeySub,
        queryFn: () => {
            if (!channel) return
            return getStatisticsSubscribers({ channel, dateStart: dates.startDate, dateEnd: dates.endDate })
        },
        enabled: !!channel
    })

    return {
        statisticsInfo: statisticsInfo.data,
        statisticsInfoSubscribers: statisticsInfoSubscribers.data,
        isStatisticsLoading: statisticsInfo.isLoading,
        dates,
        actions: {
            setDates
        }
    }
}
